import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appAllGetFacilityBooking = createAsyncThunk(
	'appFacilityBooking/appAllGetFacilityBooking',
	async (params = {}) => {
		try {
			const { page = 1, limit = 10, hub, sanstha, startDate, endDate, loading = true } = params

			let url = `/facilitybooking?page=${page}&limit=${limit}`

			if (hub) url += `&hub=${encodeURIComponent(hub)}`
			if (sanstha) url += `&sansthaId=${encodeURIComponent(sanstha)}`
			if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`
			if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`

			const response = await httpService.get(url, {}, {}, { loading })

			return response.data.data
		} catch (error) {
			toast.error(error?.message || 'Failed to fetch facility bookings')
			throw error
		}
	},
)

export const appUpdateFacilityBooking = createAsyncThunk(
	'appFacilityBooking/appUpdateFacilityBooking',
	async params => {
		//   console.log(params, "params")
		try {
			const response = await httpService.put(
				`/facilitybooking/${params.id}`,
				{},
				{
					status: params.status,
					rejectionreason: params.rejectionreason,
				},
			)
			//     console.log(response,"response")
			// toast.success("Sponsor is Updated Successfully");
			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appDeleteFacilityBooking = createAsyncThunk(
	'appFacilityBooking/appDeleteFacilityBooking',
	async id => {
		try {
			const response = await httpService.delete(`/facilitybooking/${id}`)
			if (response?.data) {
				response.data.id = id
				toast.success('Facility Booking Deleted Successfully')
			}
			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appFacilityBookingSlice = createSlice({
	name: 'FacilityBooking',
	initialState: {
		// compliancesDate: [],
		facilitylist: [],
		isloder: false,
		paginate: '',
		isdeleted: false,
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appAllGetFacilityBooking.pending), (state, action) => {
			state.isloder = true
		})
		builder.addMatcher(isAllOf(appAllGetFacilityBooking.fulfilled), (state, action) => {
			state.facilitylist = action.payload
			//		console.log(action.payload, 'hiiiii')
			const paginate = {
				hasNextPage:
					action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
				hasPrevPage: action?.payload?.pagination?.currentPage > 1,
				limit: action?.payload?.pagination?.pageSize,
				nextPage: action?.payload?.pagination?.currentPage + 1,
				page: action?.payload?.pagination?.currentPage,
				pagingCounter:
					(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
					1,
				prevPage: action?.payload?.pagination?.currentPage - 1,
				totalDocs: action?.payload?.pagination?.totalRecords,
				totalPages: action?.payload?.pagination?.totalPages,
			}
			state.paginate = paginate
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetFacilityBooking.rejected), (state, action) => {
			state.isloder = false
		})
	},
})

export default appFacilityBookingSlice.reducer
